const VALID_POSITIONS = [
  "Moneyline",
  "Point Spread",
  "Run Line",
  "Total Points Over",
  "Total Points Under",
  "Total Runs Over",
  "Total Runs Under",
]

export function betTypeCategory(bet_type: string) {
  let bet_category = '';
  if (
    bet_type.includes('Moneyline')
  ) {
    bet_category = 'ml';
  } else if (
    bet_type.includes('Point Spread') ||
    bet_type.includes('Run Line')
  ) {
    bet_category = 'ps';
  } else if (
    bet_type.includes('Total Points') ||
    bet_type.includes('Total Runs')
  ) {
    bet_category = 'ou';
  }
  return bet_category;
}

export const formatBetType = (
  bet_type: string,
  team_id_display: string,
  opp_id_display: string,
  val: number,
) => {
  var bet_category = betTypeCategory(bet_type);
  let bt = "";
  if (bet_category === "ml") {
    bt = `${team_id_display} Moneyline vs ${opp_id_display}`;
  } else if (bet_category === "ps") {
    if (val > 0) {
      bt = `${team_id_display} ${bet_type} +${val}`;
    } else {
      bt = `${team_id_display} ${bet_type} ${val}`;
    }
  } else if (bet_category === "ou") {
    bt = `${bet_type} ${val}`;
  }
  return bt;
}

export function formatPosition(position_id: string) {
  let position = position_id.toString().split('-').slice(1).join(' ');
  position = position.split(' ').map((word: string) => {
    if (word.length === 0) {
      return '';
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
  return position;
}

export function validPosition(position: string) {
  return (VALID_POSITIONS.includes(position));
}